import Immutable from 'immutable';
import moment from 'moment';

import ClassFactory from 'sharedreact/utils/ClassFactory';
import { translate } from 'sharedreact/utils/LanguageSupport';

const Content: {
  id: string,
  modificationDate: moment.Moment | null,
  userName: string,
  eventType: string,
  category: string,
  operation: string,
  details: string
} = {
  id: '',
  modificationDate: null,
  userName: '',
  eventType: '',
  category: '',
  operation: '',
  details: ''
};

function findServerName(url: URL): string {
  const serverName = (url.pathname === '/') ? url.hostname : url.pathname.split(':')[0];
  return serverName.slice(serverName.lastIndexOf('/') + 1);
}

class AuditRecord extends Immutable.Record(Content) {
  static fromJS (json: object): AuditRecord {
    return ClassFactory.createFromJson(json, AuditRecord);
  }

  get localizedType (): string {
    return translate('audit.type.' + this.eventType.replace(/ /g,'-'));
  }

  get localizedCategory (): string {
    return translate('audit.category.' + this.category.replace(/ /g,'-'));
  }
  
  getLocalizedDetails (hideDetails: boolean): string {
    const obj = JSON.parse(this.details.replace(/VALUE./g, 'VALUE_'));
    const args = obj.Args;
    const operation = obj.Operation;
    let newValue = args ? args.VALUE_NEW : '';
    let oldValue = args ? args.VALUE_OLD : '';
  
    let messageKey: string = 'audit.' + operation;
    let idpConfigName: string | undefined = undefined;
    if (operation.includes('LDAP.ENABLED') || operation.includes('USERS.WIN')) {
      if (newValue === 'true' && oldValue === 'false') {
        messageKey = messageKey + '.on';
      } else if (newValue === 'false' && oldValue === 'true') {
        messageKey = messageKey + '.off';
      }
    } else if (operation.includes('PW.POLICY')) {
      messageKey = messageKey + '.'+ newValue;
    } else if (operation.includes('IDP.CONFIG')) {
      idpConfigName = obj.IDP;
      const idpConfigManaged = (args.managed === '1'); 
      if (hideDetails && idpConfigManaged) {
        messageKey = 'audit.IDP.CONFIG.managedchanged';
      } else if (operation.includes('IDP.CONFIG.baseuri')) {
        try {
          const newBaseUrl = new URL(newValue);
          const oldBaseUrl = new URL(oldValue);
          newValue = findServerName(newBaseUrl);
          oldValue = findServerName(oldBaseUrl);
          if (newBaseUrl.hostname.includes('microsoftonline')) {
            messageKey = messageKey + '.azure';
          } else {
            messageKey = messageKey + '.okta';
          }
        } catch (error) {}
      } else if (operation.includes('IDP.CONFIG.managed')) {
        messageKey = (newValue === '1') ? messageKey + '.on' : messageKey + '.off'; 
      }
    } else if (operation.includes('LDAP.CONFIG.url')) {
      try {
        const newServerUrl = (newValue != 'null') ? new URL(newValue) : null;
        const oldServerUrl = (oldValue != 'null') ? new URL(oldValue) : null;
        if (newServerUrl != null && oldServerUrl != null) {
          newValue = findServerName(newServerUrl);
          oldValue = findServerName(oldServerUrl);
          if (newValue === oldValue) {
            messageKey = (newServerUrl.protocol === 'ldaps:') ? messageKey + '.withldaps' : messageKey + '.noldaps';
          } else {
            if (newServerUrl.protocol !== oldServerUrl.protocol) {
              messageKey = (newServerUrl.protocol === 'ldaps:') ? messageKey + '.ldaps' : messageKey + '.ldap';
            }
          }      
        }
      } catch (error) {}
    }
    if (idpConfigName != null) {
      return translate(messageKey, idpConfigName, newValue, oldValue);
    } else {
      return translate(messageKey, newValue, oldValue);
    }
  }
}

export default AuditRecord;
